import { render, staticRenderFns } from "./BedrockGuardrailForm.vue?vue&type=template&id=51d5ab47&scoped=true&"
import script from "./BedrockGuardrailForm.vue?vue&type=script&lang=js&"
export * from "./BedrockGuardrailForm.vue?vue&type=script&lang=js&"
import style0 from "./BedrockGuardrailForm.vue?vue&type=style&index=0&id=51d5ab47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d5ab47",
  null
  
)

export default component.exports